import ApplicationRecord from './ApplicationRecord';
import Link from './Link';
import ProductCategory from './ProductCategory';
import ImageRecord from './ImageRecord';
import ProductPerformance from './ProductPerformance';
import Service from './Service';
/**
 * Home page.
 *
 *
 */
export default class CompanyPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * Absolute Path
     * @type {String}
     */
    URL: '',
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,

    /**
     * @type {String}
     */
    ProductCardTitle: '',
    /**
     * @type {String}
     */
    ProductCardText: '',
    /**
     * @type {String}
     */
    ServiceCardTitle: '',
    /**
     * @type {String}
     */
    PerformanceCardTitle: '',
    /**
     * @type {Object}
     */
    _embedded: {},
  }) {
  /**
   * @return {ProductCategory}
   */
  productCategories() {
    return this._getMany('ProductCategories', c => new ProductCategory(c));
  }
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroCaption() {
    return '' + this._getOne('HeroText', String);
  }
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroImage() {
    return this._getOne('HeroImg', ImageRecord).set('alt', this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne('HeroMobileImg', ImageRecord).set(
      'alt',
      this.HeroCaption
    );
  }

  /**
   * @return {List<Link>}
   */
  links() {
    return this._getMany('Links', l => new Link(l));
  }

  /**
   * @return {List<ProductPerformance>}
   */
  performanceFiles() {
    return this._getMany('PerformanceFiles', f => new ProductPerformance(f));
  }

  /**
   * @return {ImageRecord}
   */
  performanceImage() {
    return this._getOne('PerformanceImage', ImageRecord);
  }

  /**
   * @return {List<Service>}
   */
  services() {
    return this._getMany('Services', s => new Service(s));
  }
}



// WEBPACK FOOTER //
// ./src/models/ProductPage.js